<template>
  <div class="bg-gray-100 rounded-2xl p-6 shadow-sm hover:shadow-md hover:translate-y-1 transition duration-200">
    <div class="flex items-center space-x-3 mb-4">
      <font-awesome-icon :icon="icon" class="text-bright-blue text-2xl" />
      <h3 class="text-lg font-semibold text-gray-800 tracking-tight">{{ title }}</h3>
    </div>
    <p class="text-sm text-gray-700">{{ description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    description: String,
    icon: Array,
  },
};
</script>